import React from "react";
import IconText from "../molecules/IconText";

export default ({ items }) =>
    <section className="o-benefits u-section-spacing u-container">
        { items.map((item, index) => (
            <div className="o-benefits__item" key={ index }>
                <IconText { ...item }/>
            </div>
        )) }
    </section>;
